import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import React from "react";
import {
  ReimburseLicenseModalController,
  ReimburseLicenseModalControllerDelegate,
} from "./controller";

interface State {
  isLoading: boolean;
  errorMessage: string;
}

interface Props {
  applicationId: number;
  delegate: ReimburseLicenseModalDelegate;
}

/**
 * Delegação para os eventos do componente de modal de ressarcimento.
 */
export interface ReimburseLicenseModalDelegate {
  shouldCloseModal: () => void;
  applicationShouldLogout: () => void;
  didReimburseLicenses: () => void;
}

class ReimburseLicenseModal
  extends React.Component<Props, State>
  implements ReimburseLicenseModalControllerDelegate
{
  controller: ReimburseLicenseModalController;

  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: false,
      errorMessage: "",
    };
    this.controller = new ReimburseLicenseModalController(this);
  }

  didReimburseLicenses() {
    this.props.delegate.didReimburseLicenses();
  }

  didFailReimburseLicenses(message: string) {
    this.setState({ isLoading: false, errorMessage: message });
  }

  applicationShouldLogout() {
    this.props.delegate.applicationShouldLogout();
  }

  didClickReimburse() {
    this.setState({ isLoading: true, errorMessage: "" });
    const token = localStorage.getItem("AccessToken")!;
    this.controller.reimburseLicenses(token, this.props.applicationId);
  }

  didClickClose() {
    if (this.state.isLoading) {
      return;
    }
    this.props.delegate.shouldCloseModal();
  }

  renderLoading() {
    return (
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        gap={2}
        paddingY={5}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Ressarcindo licenças...
        </Typography>
      </Box>
    );
  }

  renderForm() {
    return (
      <Box display="flex" flexDirection="column" sx={{ gap: 2 }}>
        {this.state.errorMessage && (
          <Alert
            severity="error"
            onClose={() => this.setState({ errorMessage: "" })}
          >
            {this.state.errorMessage}
          </Alert>
        )}

        <Typography color="text.secondary">
          As licenças utilizadas serão devolvidas à sua conta.
        </Typography>

        <Alert severity="warning">
          Esta ação irá <strong>excluir permanentemente</strong> todas as
          aplicações que foram iniciadas mas <strong>não concluídas</strong>{" "}
          neste lote, e não pode ser desfeita.
        </Alert>
      </Box>
    );
  }

  render() {
    return (
      <Dialog
        open
        onClose={() => this.didClickClose()}
        variant="modal"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle variant="modal">
          <CurrencyExchangeIcon />
          Ressarcir licenças
        </DialogTitle>
        <DialogContent variant="modal">
          {this.state.isLoading ? this.renderLoading() : this.renderForm()}
        </DialogContent>
        {!this.state.isLoading && (
          <DialogActions
            variant="modal"
            sx={{ flexWrap: "wrap", gap: 1, justifyContent: "end" }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={() => this.didClickClose()}
            >
              Cancelar
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={() => this.didClickReimburse()}
            >
              Ressarcir Licenças
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

export default ReimburseLicenseModal;
